import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Drawer from 'components/common/Drawer'
import PromoTeaser from 'components/common/PromoTeaser'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import TireSpecification from './TireSpecification'
import Button from 'components/common/Button/Button'
import { arrayHasValues } from 'helpers/utils'
import toggle from 'components/common/hoc/toggle'
import { SEE_ALL, SEE_FEWER, PROMO_VIEW_FEWER_QTY } from 'components/OneColumnSearchResultPage/constants'


const ProductPromotionsAndSpecs = ({
  expanded,
  promotions,
  frontTire,
  toggleHandlers: {
    onClick
  },
  rearTire,
  myStore
}) =>
  <Fragment>
    <PromoWrapper myStore={ myStore } rearTire={ rearTire }>
      {
        arrayHasValues(promotions) &&
        <Fragment>
          {
            promotions.map((
              {
                displayName,
                promotionName,
                promoId,
                promotionId,
                promotionType,
                promotionRebate
              },
              index) =>
              index < PROMO_VIEW_FEWER_QTY &&
              <Teaser
                data-at-product-promotions-teaser
                creative="tire-serp-promo-offers"
                index={ index }
                item={ promotions[index] }
                key={ index }
                promotionId={ promoId || promotionId }
                promotionRebate={ promotionRebate }
                promotionType={ promotionType }>
                {displayName || promotionName}
              </Teaser>
            )
          }
          {
            promotions.length > PROMO_VIEW_FEWER_QTY &&
            <Fragment>
              <div hidden={ !expanded } >
                {
                  promotions.map((
                    { displayName,
                      promotionName,
                      promoId,
                      promotionId,
                      promotionType,
                      promotionRebate
                    },
                    index) =>
                    index > 1 &&
                    <AdditionalTeaser
                      creative="tire-serp-promo-offers"
                      item={ promotions[index] }
                      key={ index }
                      promotionId={ promoId || promotionId }
                      promotionRebate={ promotionRebate }
                      promotionType={ promotionType }>
                      {displayName || promotionName}
                    </AdditionalTeaser>
                  )
                }
              </div>
              <ShowMorePromos link onClick={ onClick }>
                {
                  expanded ? SEE_FEWER : SEE_ALL
                }
                <HintIcon
                  asset="arrow-icon-full-black-down"
                  alternative="arrow-icon-full-black-up"
                  alt=""
                  condition={ expanded }
                  width={ 10 }
                  height={ 10 } />
              </ShowMorePromos>
            </Fragment>
          }
        </Fragment>
      }
    </PromoWrapper>
    <Specs title="See specs" rearTire={ rearTire } >
      <DetailsWrapper>
        <Fragment>
          {
            frontTire &&
            <TireSpecification title={ rearTire ? 'Front' : '' } { ...frontTire } />
          }
          {
            rearTire &&
            <TireSpecification title="Rear" hideCaption { ...rearTire } />
          }
        </Fragment>
      </DetailsWrapper>
    </Specs>
  </Fragment>


ProductPromotionsAndSpecs.propTypes = {
  expanded: PropTypes.bool,
  frontTire: PropTypes.PropTypes.shape(),
  myStore: PropTypes.PropTypes.shape(),
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  rearTire: PropTypes.PropTypes.shape(),
  sizeRear: PropTypes.string,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  })
}

export default toggle(ProductPromotionsAndSpecs)
const HintIcon = styled(Icon)`
  display: inline-block;
  margin: 0 0 3px 5px;
  text-align: right;
  cursor: pointer;
  ${Media.desktop`
    vertical-align: middle;
  `}
  ${Media.mobile`
    width: 10px;
    height: 10px;
  `}
`
const ShowMorePromos = styled(Button)`
  && {
    height: 11px;
    color: ${Theme.colors.dark_grey};
    ${Mixin.font.GothamBold(14)}
    text-transform: uppercase;
    margin: 10px 0;
    cursor: pointer;
  }
`

const PromoWrapper = styled.div`
  min-height: 35px;
  ${props => props.rearTire && css`
    min-height: ${props => props.myStore ? '140px' : '25px'};
  `}
`

const Specs = styled(Drawer)`
  border-width: 1px 0 0;
  margin: 0 -20px;
  margin-top: 16px;
  padding: 21px 25px;
  ${Media.tabletSmall`
    margin: 16px -5px 0 0;
  `}

  & img {
    top: 21px;
  }
`

const DetailsWrapper = styled.div`
  display: table;
  width: 100%;
  padding: 10px 0 0;
`

const Teaser = styled(PromoTeaser)`
  ${Media.tabletSmall`
    margin-left: 20px;
  `}
`

const AdditionalTeaser = styled(PromoTeaser)`
  &:first-child {
    margin-top: 15px;
  }

  &:last-child {
    margin-bottom: 10px;
  }
`
